/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { createApi } from '@reduxjs/toolkit/query/react';

import { GenerateOtpRequest, JimboResponse, VerifyOtpRequest } from '@models';
import { baseQueryWithReauth } from '@services/refreshToken.service';

export const VerificationApi = createApi({
  reducerPath: 'VerificationApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Verification'],
  endpoints: (builder) => ({
    generateOneTimePassword: builder.mutation<void, GenerateOtpRequest>({
      query: (req) => ({
        url: `/verification/generate`,
        method: 'POST',
        body: req,
      }),
    }),
    verifyOneTimePassword: builder.mutation<JimboResponse<boolean>, VerifyOtpRequest>({
      query: (req) => ({
        url: `/verification/verify`,
        method: 'POST',
        body: req,
      }),
    }),
    isCustomerVerified: builder.mutation<JimboResponse<boolean>, { userId: string }>({
      query: ({ userId }) => ({
        url: `verification/verified/${userId}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGenerateOneTimePasswordMutation, useVerifyOneTimePasswordMutation, useIsCustomerVerifiedMutation } = VerificationApi;
